import React, { Component } from 'react';
import { filter, find, forEach, get, map, toString } from 'lodash';
import { Elements } from 'react-stripe-elements';
import { Col, Radio, Row } from 'antd';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import validator from 'validator';
import helpers from 'utils/helpers';
import styled from 'styled-components';

import {
  addCouponRequest,
  getCouponsRequest,
  getPaymentMethodsRequest
} from 'ducks/users';
import { getAvailableCampaignsRequest } from 'ducks/campaigns';
import {
  PaymentFont,
  StyledButton,
  StyledFormItem,
  StyledInput,
  StyledRadioGroup
} from 'components/Styled';
import InjectedStripeForm from './StripeForm';
import Coupon from 'components/Account/PromoCode/Coupon';
import AsiaMilesCard from 'components/campaign/AsiaMiles/AsiaMilesCard';
import CampaignForm from 'components/campaign/CampaignForm';

const ImageDiv = styled.div`
  padding: 4px 0;

  img {
    margin-right: 6px;
  }
`;

const PaymentMethodsRadio = styled(Radio)`
  &.alipayGlobalWap {
    @media (min-width: 768px) {
      display: none;
    }
  }

  &.alipayGlobalWeb {
    @media (max-width: 767px) {
      display: none;
    }
  }
`;

class CheckoutForm extends Component {
  state = {
    couponLoaded: false,
    code: {
      value: '',
      status: '',
      help: ''
    },
    paymentMethod: 'stripe',
    member: {
      value: '',
      status: '',
      help: ''
    },
    firstName: '',
    lastName: ''
  };

  validations = {};
  clientCountry = helpers.getCurrentCountry(true);

  addRule = (prefix, label, type = 'required') => {
    this.validations[label] = {
      type,
      messages: {
        empty: this.props.t(`${prefix}.err_msg.${label}.empty`),
        format: this.props.t(`${prefix}.err_msg.${label}.format`)
      }
    };
  };

  onRadioChange = e => {
    this.props.handleRadioChange(e.target.value);
  };

  onRadioClick = value => {
    if (this.props.coupon === value) {
      this.props.handleRadioChange('');
    }
  };

  handlePaymentMethodChange = e => {
    this.setState({
      paymentMethod: e.target.value
    });
  };

  handleSubmitPromoCode = e => {
    e.preventDefault();
    this.handleClickPromoCode();
  };

  handleClickPromoCode = () => {
    const fields = ['code'];
    let success = true;

    forEach(fields, label => {
      if (!this.validate(label)) {
        success = false;
      }
    });

    if (!success) {
      helpers.message.error(
        this.props.t('error_code.add-coupon-fail-empty'),
        'payment'
      );
      return;
    }

    window.dataLayer.push({
      event: 'Submit Promo Code',
      promoData: {
        code: this.state.code.value
      }
    });

    this.props.addCouponRequest({
      user: this.props.user,
      code: this.state.code.value
    });
  };

  renderTextInput = (label, placeholder) => {
    return (
      <StyledFormItem
        validateStatus={get(this.state, [label, 'status']) || ''}
        help={this.props.t(get(this.state, [label, 'help']))}>
        <StyledInput
          size="large"
          value={get(this.state, [label, 'value'])}
          onChange={e => {
            this.handleTextInputChange(e.target.value, label);
          }}
          onBlur={e => {
            this.handleTextInputBlur(label);
          }}
          disabled={this.props.carrier === 'speedpost'}
          placeholder={placeholder}
        />
      </StyledFormItem>
    );
  };

  handleTextInputChange = (value, label) => {
    this.setState({
      [label]: {
        ...this.state[label],
        value
      }
    });
  };

  handleTextInputBlur = label => {
    if (label === 'code') {
      this.validate(label);
    } else {
      this.validateId(label);
    }
  };

  validateId = label => {
    const results = this.getIdErrorMessage(label);

    this.setState({
      [label]: {
        ...this.state[label],
        status: results ? 'error' : '',
        help: results
      }
    });

    return !results;
  };

  validate = label => {
    const results = this.getErrorMessage(label);

    this.setState({
      [label]: {
        ...this.state[label],
        status: results ? 'error' : '',
        help: results
      }
    });

    return !results;
  };

  getIdErrorMessage = label => {
    let patterns;
    const value = toString(this.state[label].value);

    if (value.length > 15 || value.length < 11) {
      return this.props.t('campaigns.err_msg.member.length');
    }

    switch (this.validations[label].type) {
      case 'required':
        patterns = /^(?:259|50|53|55|56|57|99150)[0-9]+$/i;

        if (validator.isEmpty(value, { ignore_whitespace: true })) {
          return get(this.validations[label], 'messages.empty');
        }

        if (!patterns.test(value)) {
          return get(this.validations[label], 'messages.format');
        }

        return null;
      default:
        return null;
    }
  };

  getErrorMessage = label => {
    let patterns;
    const value = toString(this.state[label].value);

    if (value.length > 35) {
      return this.props.t('common.err_msg.length');
    }

    switch (this.validations[label].type) {
      case 'required':
        patterns = /^[0-9A-Z\s\-_.,/'"():;$&@!?]+$/i;

        if (validator.isEmpty(value, { ignore_whitespace: true })) {
          return get(this.validations[label], 'messages.empty');
        }

        if (!patterns.test(value)) {
          return get(this.validations[label], 'messages.format');
        }

        return null;
      default:
        return null;
    }
  };

  componentDidMount() {
    this.props.getCouponsRequest({
      user: this.props.user,
      routeData: this.props.routeData
    });

    this.props.getPaymentMethodsRequest();

    this.addRule('promo_codes', 'code', 'required');
    this.addRule('campaigns', 'member', 'required');

    window.addEventListener('resize', this.handleScreenSizeChange);

    this.props.getAvailableCampaignsRequest({
      orderRef: this.props.orderRef
    });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleScreenSizeChange);
  }

  handleScreenSizeChange = () => {
    if (this.state.paymentMethod === 'alipayGlobalWap') {
      if (window.innerWidth >= 768) {
        this.setState({
          paymentMethod: 'stripe'
        });
      }
    }

    if (this.state.paymentMethod === 'alipayGlobalWeb') {
      if (window.innerWidth < 768) {
        this.setState({
          paymentMethod: 'stripe'
        });
      }
    }
  };

  componentDidUpdate(prevProps) {
    if (!prevProps.addCouponSuccess && this.props.addCouponSuccess) {
      this.props.getCouponsRequest({
        user: this.props.user,
        routeData: this.props.routeData
      });

      this.setState({
        couponLoaded: true
      });
    }

    if (prevProps.coupons !== this.props.coupons && this.state.couponLoaded) {
      if (prevProps.coupons.length === this.props.coupons.length) {
        // add coupon success but not eligible to this shipment
        helpers.message.warning(
          window.t('error_code.add-coupon-success-not-eligible'),
          'payment'
        );
      } else {
        helpers.message.success(
          window.t('error_code.add-coupon-success'),
          'payment'
        );
      }
    }

    if (prevProps.campaignData !== this.props.campaignData) {
      this.setState({
        member: {
          value: this.props.campaignData.memberRef,
          status: '',
          help: ''
        },
        firstName: this.props.campaignData.firstName,
        lastName: this.props.campaignData.lastName
      });
    }
  }

  render() {
    return (
      <React.Fragment>
        <div
          // className="payment-grid"
          style={{
            backgroundColor: '#f5f5f5',
            padding: '30px 15px',
            boxShadow: 'none !important'
          }}>
          <Row
            type="flex"
            align="bottom"
            style={{
              paddingBottom: '15px',
              borderBottom: '1px solid #ccc'
            }}>
            <Col
              span={24}
              style={{
                fontSize: '20px',
                fontWeight: 700
              }}>
              {this.props.t('payment.offers')}
            </Col>
          </Row>
          <Row>
            <Col style={{ padding: '15px 0 6px', fontWeight: 700 }}>
              {this.props.t('promo_codes.input_promo_code')}
            </Col>
          </Row>
          <form onSubmit={this.handleSubmitPromoCode}>
            <Row type="flex" align="top" gutter={16}>
              <Col style={{ flex: 1 }}>{this.renderTextInput('code', '')}</Col>
              <Col>
                <StyledButton
                  type="primary"
                  htmlType="submit"
                  style={{
                    width: '112px',
                    height: '40px'
                  }}
                  disabled={this.props.carrier === 'speedpost'}
                  loading={this.props.loading}
                  shadow="true">
                  {this.props.t('button.confirm')}
                </StyledButton>
              </Col>
            </Row>
          </form>
          <Row>
            <Col span={24} style={{ padding: '15px 0 25px' }}>
              <StyledRadioGroup
                onChange={this.onRadioChange}
                value={this.props.coupon}>
                {(() => {
                  if (this.props.coupons.length) {
                    return map(this.props.coupons, coupon => {
                      return (
                        <Radio
                          key={coupon.code}
                          value={coupon.code}
                          onClick={() => {
                            this.onRadioClick(coupon.code);
                          }}>
                          <Coupon coupon={coupon} />
                        </Radio>
                      );
                    });
                  }

                  return (
                    <div style={{ color: '#2C2C2E', fontSize: '12px' }}>
                      {this.props.t(
                        this.props.carrier === 'speedpost'
                          ? 'promo_codes.no_speedpost'
                          : 'promo_codes.no_coupon'
                      )}
                    </div>
                  );
                })()}
              </StyledRadioGroup>
            </Col>
          </Row>
          {this.clientCountry === 'HK' &&
            this.props.campaign &&
            this.props.campaignData && (
              <>
                {this.props.campaign === 'asiamiles' ? (
                  <AsiaMilesCard
                    membershipNumber={this.state.member.value}
                    onMembershipNumberChange={newValue =>
                      this.setState({
                        member: { value: newValue }
                      })
                    }
                    reward={get(this.props.campaignData, 'offer.variance')}
                    fistName={this.state.firstName}
                    onFirstNameChange={newValue =>
                      this.setState({ firstName: newValue })
                    }
                    lastName={this.state.lastName}
                    onLastNameChange={newValue =>
                      this.setState({ lastName: newValue })
                    }
                  />
                ) : (
                  <CampaignForm
                    campaignData={this.props.campaignData}
                    renderTextInput={this.renderTextInput}
                  />
                )}
              </>
            )}
          <Row
            type="flex"
            align="bottom"
            style={{
              paddingBottom: '15px',
              borderBottom: '1px solid #ccc'
            }}>
            <Col
              span={9}
              style={{
                fontSize: '20px',
                fontWeight: 700
              }}>
              {this.props.t(
                this.clientCountry === 'HK'
                  ? 'payment.payment'
                  : 'payment.charge_with_credit_card'
              )}
            </Col>
            <Col
              span={15}
              style={{
                textAlign: 'right',
                fontSize: '12px'
              }}>
              {this.props.t('payment.payment_desc')}
            </Col>
          </Row>
          {this.clientCountry === 'HK' && (
            <Row
              type="flex"
              align="bottom"
              style={{
                padding: '15px 0',
                borderBottom: '1px solid #ccc'
              }}>
              <Col span={24}>
                <div
                  style={{
                    fontWeight: 700,
                    paddingBottom: '10px'
                  }}>
                  {this.props.t('payment.payment_methods')}
                </div>
                <div>
                  <StyledRadioGroup
                    onChange={this.handlePaymentMethodChange}
                    value={this.state.paymentMethod}>
                    {(() => {
                      let paymentMethods = this.props.paymentMethods;

                      paymentMethods = filter(
                        paymentMethods,
                        x => x.enable && x.platforms.web && x.slug!=='alipayGlobalWap' && x.slug!=='alipayGlobalWeb'
                      );

                      if (!paymentMethods.length) {
                        return null;
                      }

                      const images = {
                        stripe: (
                          <ImageDiv>
                            <img
                              style={{ width: '37px' }}
                              src="https://spaceship-product-images.s3.ap-east-1.amazonaws.com/image/visa.svg"
                            />
                            <img
                              style={{ width: '26.3px' }}
                              src="https://spaceship-product-images.s3.ap-east-1.amazonaws.com/image/amex.svg"
                            />
                            <img
                              style={{ width: '25.8px' }}
                              src="https://spaceship-product-images.s3.ap-east-1.amazonaws.com/image/mastercard.svg"
                            />
                          </ImageDiv>
                        ),
                        alipayGlobalWeb: (
                          <ImageDiv>
                            <img
                              style={{ width: '26px' }}
                              src="https://spaceship-product-images.s3.ap-east-1.amazonaws.com/image/alipay.svg"
                            />
                          </ImageDiv>
                        ),
                        alipayGlobalWap: (
                          <ImageDiv>
                            <img
                              style={{ width: '26px' }}
                              src="https://spaceship-product-images.s3.ap-east-1.amazonaws.com/image/alipay.svg"
                            />
                          </ImageDiv>
                        )
                      };

                      return (
                        <>
                          {map(paymentMethods, x => {
                            return (
                              <PaymentMethodsRadio
                                key={x.slug}
                                value={x.slug}
                                className={x.slug}>
                                <Row align="middle">
                                  <Col style={{ width: '100px' }}>
                                    {this.props.t(
                                      `payment.payment_method_${x.slug}`
                                    )}
                                  </Col>
                                  <Col>{images[x.slug]}</Col>
                                </Row>
                              </PaymentMethodsRadio>
                            );
                          })}
                        </>
                      );
                    })()}
                  </StyledRadioGroup>
                </div>
              </Col>
            </Row>
          )}
          {(this.state.paymentMethod === 'alipayGlobalWeb' ||
            this.state.paymentMethod === 'alipayGlobalWap') && (
            <>
              <div style={{ fontWeight: 700, padding: '16px 0' }}>
                {this.props.t('payment.credit_card_is_required')}
              </div>
              <Row style={{ paddingBottom: '15px' }} gutter={15} align="middle">
                <Col style={{ textAlign: 'center' }}>
                  {this.props.t('payment.shipment_payment')}
                  <br />
                  <img
                    style={{ width: '26px', marginTop: '5px' }}
                    src="https://spaceship-product-images.s3.ap-east-1.amazonaws.com/image/alipay.svg"
                  />
                </Col>
                <Col style={{ textAlign: 'center' }}>
                  {' '}
                  <br />
                  <img
                    style={{ width: '49.4px' }}
                    src="https://spaceship-product-images.s3.ap-east-1.amazonaws.com/image/payment-adjustment.svg"
                  />
                </Col>
                <Col style={{ textAlign: 'center' }}>
                  {this.props.t('payment.payment_adjustment')}
                  <br />
                  <img
                    style={{ width: '30.4px', marginTop: '5px' }}
                    src="https://spaceship-product-images.s3.ap-east-1.amazonaws.com/image/card.svg"
                  />
                </Col>
              </Row>
              <div style={{ fontSize: '12px', color: '#2C2C2E' }}>
                {this.props.t('payment.credit_card_is_required_remarks')}
              </div>
            </>
          )}
          <div style={{ paddingTop: '20px' }}>
            <Elements
              fonts={[
                {
                  cssSrc:
                    'https://fonts.googleapis.com/css?family=Source+Sans+Pro:400,700&display=swap'
                }
              ]}>
              <InjectedStripeForm
                t={this.props.t}
                shipmentRef={this.props.shipmentRef}
                pickupRef={this.props.pickupRef}
                orderRef={this.props.orderRef}
                coupon={this.props.coupon}
                discount={this.props.discount}
                shipmentData={this.props.shipmentData}
                paymentMethod={this.state.paymentMethod}
                canAdjustment={get(
                  find(this.props.paymentMethods, [
                    'slug',
                    this.state.paymentMethod
                  ]),
                  'canAdjustment'
                )}
                memberRef={get(this.state.member, 'value')}
                campaign={this.props.campaign}
                memberRefStatus={get(this.state.member, 'status')}
                firstName={this.state.firstName}
                lastName={this.state.lastName}
              />
            </Elements>
          </div>
          <div style={{ textAlign: 'center', paddingBottom: '25px' }}>
            <div style={{ fontSize: '12px', padding: '10px 0' }}>
              {this.props.t('payment.payment_by')}
            </div>
            <PaymentFont margin>
              <FontAwesomeIcon icon={['fab', 'cc-stripe']} />
            </PaymentFont>
            <PaymentFont margin>
              <FontAwesomeIcon icon={['fab', 'cc-visa']} />
            </PaymentFont>
            <PaymentFont margin>
              <FontAwesomeIcon icon={['fab', 'cc-mastercard']} />
            </PaymentFont>
            <PaymentFont margin>
              <FontAwesomeIcon icon={['fab', 'cc-amex']} />
            </PaymentFont>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const obj = {};
  const arr = state.campaigns.availableCampaigns || [];
  arr.forEach(c => (obj[c.campaignSlug] = c));

  const campaignSlug =
    get(state.campaigns.campaignData, 'campaignSlug') ||
    localStorage.campaign ||
    'asiamiles';
  const campaignData = obj[campaignSlug];
  return {
    user: state.auth.user || false,
    loading: !!(state.users.loading && state.users.coupons),
    coupons: state.users.coupons || false,
    paymentMethods: state.users.paymentMethods || [],
    addCouponSuccess: !!state.users.addCouponSuccess,
    campaign: campaignSlug,
    campaignData
  };
};

const mapDispatchToProps = {
  getCouponsRequest,
  addCouponRequest,
  getPaymentMethodsRequest,
  getAvailableCampaignsRequest
};

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutForm);
